"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompensationAction = exports.DisputeAction = exports.BondType = exports.TradeSide = exports.OfferState = exports.TradeState = exports.OFFER_SIZE = exports.TRADE_SIZE = exports.MARKET_STATE_SIZE = exports.sizeOf = exports.ESCROW_CODER = exports.AccountName = void 0;
const anchor_1 = require("@project-serum/anchor");
const escrow_json_1 = __importDefault(require("../artifacts/escrow.json"));
const IDL = escrow_json_1.default;
var AccountName;
(function (AccountName) {
    AccountName["EscrowConfig"] = "EscrowConfig";
    AccountName["MarketState"] = "MarketState";
    AccountName["Trade"] = "Trade";
    AccountName["Profile"] = "Profile";
    AccountName["ArbitratorCert"] = "ArbitratorCert";
    AccountName["TokenInfo"] = "TokenInfo";
    AccountName["Offer"] = "Offer";
})(AccountName = exports.AccountName || (exports.AccountName = {}));
exports.ESCROW_CODER = new anchor_1.BorshAccountsCoder(IDL);
const sizeOf = (accountName) => {
    var _a;
    const idlAccount = (_a = IDL.accounts) === null || _a === void 0 ? void 0 : _a.find((account) => account.name == accountName);
    if (idlAccount) {
        return exports.ESCROW_CODER.size(idlAccount);
    }
    return -1;
};
exports.sizeOf = sizeOf;
exports.MARKET_STATE_SIZE = (0, exports.sizeOf)(AccountName.MarketState);
exports.TRADE_SIZE = 598; //sizeOf(AccountName.Trade);
exports.OFFER_SIZE = 629; //sizeOf(AccountName.Offer);
exports.TradeState = {
    Awaiting: { awaiting: {} },
    Deposited: { deposited: {} },
    Disputed: { disputed: {} },
    Released: { released: {} },
    Canceled: { canceled: {} },
};
exports.OfferState = {
    Awaiting: { awaiting: {} },
    Canceled: { canceled: {} },
    OutOfFund: { outOfFund: {} },
    Fulfilled: { fulfilled: {} },
};
exports.TradeSide = {
    Buy: { buy: {} },
    Sell: { sell: {} },
};
exports.BondType = {
    Native: { native: {} },
    Spl: { spl: {} },
};
exports.DisputeAction = {
    Release: { release: {} },
    Cancel: { cancel: {} },
};
exports.CompensationAction = {
    NoCompensate: { noCompensate: {} },
    CompensateSeller: { compensateSeller: {} },
    CompensateBuyer: { compensateBuyer: {} },
};
